export default __webpack_public_path__ + "static/media/Barbieri-MarcaGrafica.21b211bb.png";